(function () {
  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var reveals = root.querySelectorAll('.sh-reveal');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          var intro = entry.target.closest('[data-sh-intro]');
          if (intro) intro.classList.add('is-active');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12 });
      reveals.forEach(function (el) { observer.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    }

    root.querySelectorAll('[data-sh-modes]').forEach(function (widget) {
      var stage = widget.querySelector('.sh-mode-stage');
      var word = widget.querySelector('[data-mode-word]');
      var note = widget.querySelector('[data-mode-note]');
      var tabs = widget.querySelectorAll('.sh-mode-tab');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (item) { item.setAttribute('aria-selected', 'false'); });
          tab.setAttribute('aria-selected', 'true');
          stage.dataset.state = tab.dataset.state;
          word.textContent = tab.dataset.word;
          note.textContent = tab.dataset.note;
        });
      });
    });

    root.querySelectorAll('[data-sh-bloom]').forEach(function (widget) {
      var stage = widget.querySelector('.sh-bloom-stage');
      var word = widget.querySelector('[data-bloom-word]');
      var note = widget.querySelector('[data-bloom-note]');
      var tabs = widget.querySelectorAll('.sh-bloom-tab');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (item) { item.setAttribute('aria-selected', 'false'); });
          tab.setAttribute('aria-selected', 'true');
          stage.dataset.bloomState = tab.dataset.state;
          word.textContent = tab.dataset.word;
          note.textContent = tab.dataset.note;
        });
      });
    });

    root.querySelectorAll('[data-sh-buy]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var product = document.querySelector('product-info');
        if (!product) return;
        event.preventDefault();
        product.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    });

    root.querySelectorAll('[data-sh-waitlist]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (form.dataset.previewOnly !== 'true') return;
        event.preventDefault();
        var note = form.parentElement.querySelector('[data-waitlist-note]');
        if (note) note.textContent = 'Design preview only — the live wait-list connection will be added at launch.';
      });
    });

    root.addEventListener('pointermove', function (event) {
      var rect = root.getBoundingClientRect();
      root.style.setProperty('--mx', ((event.clientX - rect.left) / rect.width * 100) + '%');
      root.style.setProperty('--my', ((event.clientY - rect.top) / Math.max(rect.height, 1) * 100) + '%');
    }, { passive: true });
  }

  document.querySelectorAll('[data-sweat-hat-story]').forEach(init);
  document.querySelectorAll('[data-scroll-waitlist]').forEach(function (button) {
    button.addEventListener('click', function () {
      var target = document.getElementById('waitlist');
      if (target) target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  });
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-sweat-hat-story]'));
  });
})();
